export class ModalCatalog {
	private element: HTMLElement;
	private categories: NodeListOf<Element>;
	private readonly categoryActiveClass: string = 'modal-catalog__item--active';
	private readonly subcategoryActiveClass: string = 'header-catalog-category__subcategory--active';
	constructor(element) {
		if (!element) return;
		this.element = element;
		this.categories = this.element.querySelectorAll('.modal-catalog__item');

		this.init();
	}

	private openCategory = (category): void => category.classList.add(this.categoryActiveClass);
	private closeCategory = (category): void => category.classList.remove(this.categoryActiveClass);

	private handleCategoryClick = (event): void => {
		const { target, currentTarget } = event;
		const link = target.closest('.modal-catalog__category-link');
		const content = currentTarget.querySelector('.modal-catalog__category-content');
		const backButton = target.closest('.header-catalog-category__back');
		const subtitle = target.closest('.header-catalog-category__subtitle');
		if (link && content) {
			event.preventDefault();
			this.openCategory(currentTarget);
		} else if (backButton) {
			this.closeCategory(currentTarget);
		} else if (subtitle) {
			subtitle.parentNode.classList.toggle(this.subcategoryActiveClass);
		}
	};

	public init = (): void => {
		this.categories.forEach((category) => category.addEventListener('click', this.handleCategoryClick));
	};
}
